const ABUSES = {
  spam: 'reportSpam',
  offensive: 'reportOffensive',
  other: 'reportOther',
};

// eslint-disable-next-line import/prefer-default-export
export { ABUSES };
